import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { ReportsContext } from '../reports.context';
import { NavigationService } from '../../navbar/navigation.service';
import _ from 'lodash';

@Component({
    selector: 'adm4-report-generation-output',
    template: `
    <div class='generation-output-container'>
      @if (reportsContext.showGenerationOutput$ | async) {
        @if (isSafeHtml(reportsContext.generationOutput$ | async) ) {
          <div [innerHtml]='reportsContext.generationOutput$ | async'></div>
        } @else {
          <iframe [srcdoc]="reportsContext.generationOutput$ | async | reportsHtml" style="display: block; width: 100%; height: 100%; border: none;"></iframe>
        }
      }
      @if (reportsContext.notGenerated$ | async) {
        <div class="content">Please select an inventory to generate this report.</div>
      }
      @if (reportsContext.isGenerationInProgress$ | async) {
        <div class="content">
          <span class='generation-in-progress'><mat-spinner [diameter]='50'></mat-spinner></span>
          <span>Generating report - Inventory: {{inventoryKey}}</span>
        </div>
      }
      @if (reportsContext.isGenerationFailed$ | async) {
        <div class="content failed">
          <p>The report could not be generated.</p>
          <p>Please check the project for issues. Also, you can go to step 2 in the <a (click)='onOpenDeploymentWizard()'>
          deployment wizard</a> to validate the project against the selected inventory.</p>
        </div>
      }
      @if (reportsContext.isNothingToDo$ | async) {
        <div class="content failed">
          <p>The report could not be generated.</p>
          <p>Please make sure that the project has at least an instance pattern to be able to generate the
          report.</p>
        </div>
      }
    </div>
    `,
    styleUrls: ['report-generation-output.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ReportGenerationOutputComponent {
  reportsContext = inject(ReportsContext);
  private navigationService = inject(NavigationService);

  @Input() inventoryKey: string;

  onOpenDeploymentWizard() {
    this.navigationService.navigateToDeploymentWizard();
  }

  isSafeHtml(html: string) {
    return !_.includes(html, '<script');
  }
}
